import * as React from "react";
import {useEffect, useState} from "react";
import {Button, InputNumber, Popover, Slider} from "antd";
import {CloseOutlined} from "@ant-design/icons";

interface RcrTagProps {
    closeSelectDropdown: ()=>void
    onRemove: (event?: React.MouseEvent<HTMLElement, MouseEvent>)=>void
    value: string
    setValue: (value: string)=>void
    rcrOpen: boolean
    setRcrOpen: (open: boolean)=>void
}

export function RcrTag(props: RcrTagProps) {
    const [rcr, setRcr] = useState<string>("2.5")

    useEffect(()=>{
        if (props.value.startsWith("rcr:")) {
            const rcr = props.value.split(':', 2)[1].trim()
            setRcr(rcr)
        }
    }, [props.value])

    function getButtonTitle() {
        if (!props.value || props.value==='rcr') return "Set minimum RCR"
        return "RCR>=" + props.value.split(':', 2)[1].trim()
    }

    return <div className={'tag'} onMouseDown={e=>e.stopPropagation()}>
        <Popover content={
            <div style={{display: "flex", gap: 10, flexDirection: "column", alignItems: "flex-end"}}>
                <div style={{display: "flex", gap: 16}}>
                    <Slider
                        style={{flex: 1, width: 200}}
                        min={0}
                        max={10}
                        onChange={v=>setRcr(v.toString())}
                        value={Number(rcr)}
                        step={0.1}
                    />
                    <InputNumber
                        min={0}
                        max={10}
                        step={0.1}
                        value={Number(rcr)}
                        onChange={v=>v && setRcr(v.toString())}
                    />
                </div>
                <div>
                    <Button type={"primary"} onClick={()=>{
                        props.setValue(rcr)
                        props.setRcrOpen(false)
                    }}>OK</Button>
                </div>
            </div>}
                 style={{width: 400}}
                 arrow={false}
                 trigger={'click'}
                 placement={"bottomLeft"}
                 destroyTooltipOnHide={true}
                 align={{offset: [0, 6]}}
                 onOpenChange={(open)=>{
                     if (open) {
                         props.closeSelectDropdown()
                     }
                     props.setRcrOpen(open)
                 }}
                 open={props.rcrOpen}
        >
            <Button size={"small"} type={'link'}>{getButtonTitle()}</Button>
        </Popover>
        <Button type={'text'} size={"small"} className={'close-tag'} onClick={props.onRemove}><CloseOutlined/></Button>
    </div>
}

